<div class="header">
  <h3>Existing user names</h3>
  <button mat-icon-button (click)="closeUsersTable.emit()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z0 full-width">
  <ng-container matColumnDef="userName">
    <th mat-header-cell *matHeaderCellDef>User name</th>
    <td mat-cell *matCellDef="let u">{{ u.userId }}</td>
  </ng-container>

  <ng-container matColumnDef="firstName">
    <th mat-header-cell *matHeaderCellDef>First name</th>
    <td mat-cell *matCellDef="let u">{{ u.firstName }}</td>
  </ng-container>

  <ng-container matColumnDef="lastName">
    <th mat-header-cell *matHeaderCellDef>Last Name</th>
    <td mat-cell *matCellDef="let u">{{ u.lastName }}</td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>Email</th>
    <td mat-cell *matCellDef="let u">{{ u.email }}</td>
  </ng-container>

  <ng-container matColumnDef="teamLead">
    <th mat-header-cell *matHeaderCellDef>Team lead</th>
    <td mat-cell *matCellDef="let u">{{ u.teamLead }}</td>
  </ng-container>

  <ng-container matColumnDef="userRoles">
    <th mat-header-cell *matHeaderCellDef>User role</th>
    <td mat-cell *matCellDef="let u">{{ formatRoles(u.roles) }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
